
$('.js-button-accordion').on('click',function(){
  if($(this).hasClass('disabled')){
    return false;
  }
  if(!$(this).hasClass('show')){
    $(this).addClass('show');
    $(this).next().addClass('show');

    if($('#js-category-box').length > 0){
      const wrapperH = $('#js-category-box').outerHeight(true) + targetH;
      $('#js-category-box').height(wrapperH);
    }

  } else {
    $(this).removeClass('show');
    $(this).next().removeClass('show');

    if($('#js-category-box').length > 0){
      const wrapperH = $('#js-category-box').outerHeight(true) - currenttargetH;
      $('#js-category-box').height(wrapperH);
    }
  }
});

$('.js-button-accordion2').on('click',function(){
  $(this).hide();
  $(this).next().show();
});
